<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('tuition_assistance_re_evaluation_request_detail')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('tuition_assistance_re_evaluation_request_detail')"
                              :isFilter="false"/>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <div class="mb-4">
                        <h6 class="text-uppercase mb-0">{{ $t('information').toUpper() }}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('name')">{{ studentFormData.name}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('surname')">{{studentFormData.surname}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('cgpa')">{{studentFormData.gpa}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('prior_rate')">{{studentFormData.prior_rate}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('explanation')">{{studentFormData.explanation}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('semester') + '/' + $t('semester')">
                        {{
                            studentFormData.semester
                                ? studentFormData.academic_year +
                                " / " +
                                studentFormData.semester
                                : "-"
                        }}
                    </b-form-group>
                </div>
            </div>
            <hr>
            <div class="my-3 d-inline-block"></div>
            <div class="mb-4">
                <h6 class="text-uppercase mb-0">{{ $t('documents').toUpperCase() }}</h6>
            </div>
            <div v-if="studentFormData.files && studentFormData.files.length > 0" class="mb-3">
                <b-list-group>
                    <b-list-group-item
                        v-for="(file, index) in studentFormData.files"
                        :key="file.uuid || file.id || index"
                        class="d-flex align-items-center justify-content-between"
                    >
                        <div class="d-flex align-items-center">
                            <i class="ri-file-2-line mr-2" style="font-size: 1.2rem"></i>
                            <div>
                                <div class="font-weight-medium">{{ file.file_name }}</div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center">
                            <b-button size="sm" variant="link" @click="download(file)">
                                <i class="ri-download-2-line"></i> {{ $t('download') }}
                            </b-button>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </div>
            <div class="my-3 d-inline-block"></div>
            <div v-if="checkPermission('tuitionassistancereevaluation_approve')">
                <ValidationObserver ref="studentForm">
                    <b-row>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('status')">
                                    <parameter-selectbox
                                        v-model="formData.status"
                                        :code="'tuition_assistance_re_evaluations_statuses'"
                                        :validate-error="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" v-if="formData.status === 'approved'">
                            <ValidationProvider name="approved_rate"  :rules="formData.status === 'approved' ? 'required' : ''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('approved_rate')">
                                    <b-form-input type="text" v-model="formData.approved_rate"
                                                  :state="errors[0] ? false : null"/>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" v-if="formData.status === 'approved'">
                            <ValidationProvider name="semester_id" :rules="formData.status === 'approved' ? 'required' : ''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('semester')">
                                    <semesters-selectbox
                                        :validate-error="errors[0]"
                                        v-model="formData.semester_id">
                                    </semesters-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" v-if="formData.status === 'approved'" >
                            <ValidationProvider name="scholarship_type_id"  :rules="formData.status === 'approved' ? 'required' : ''" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('scholarship_type')">
                                    <scholarship-types-selectbox v-model="formData.scholarship_type_id" :main="true">
                                    </scholarship-types-selectbox>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" v-if="formData.status === 'declined'" >
                            <ValidationProvider name="reason" :rules="formData.status === 'declined' ? 'required' : ''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('reason')">
                                    <b-form-textarea v-model="formData.reason"
                                                     :class="errors[0] ? 'is-invalid':''"
                                                     rows="5"
                                    />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </ValidationObserver>
                <div class="d-flex justify-content-center">
                    <b-form-group>
                        <b-button variant="primary" @click="approve">{{ $t('application_approve') }}</b-button>
                    </b-form-group>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import TuitionAssistanceService from "@/services/TuitionAssistanceService";
import ScholarshipTypesSelectbox from "@/components/interactive-fields/ScholarshipTypesSelectbox.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        ValidationProvider,
        ValidationObserver,
        ScholarshipTypesSelectbox,
    },
    data() {
        return {
            formData: {
                status: null,
                scholarship_type_id: null,
                approved_rate: null,
                semester_id: null,
            },
            studentFormData: {},
            studentProgramId: null,
        }
    },
    metaInfo() {
        return {
            title: this.$t('tuition_assistance_re_evaluation_request_detail')
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            try {
                const response = await TuitionAssistanceService.get(this.$route.params.id)
                this.studentFormData = response.data.data

                this.formData.status = this.studentFormData.status ?? null
                this.formData.approved_rate = this.studentFormData.approved_rate ?? this.studentFormData.prior_rate ?? null
                this.formData.semester_id = this.studentFormData.semester_id ?? this.studentFormData.semester_id ?? null
                this.formData.scholarship_type_id = this.studentFormData.scholarship_type_id ?? null
                this.formData.reason = this.studentFormData.reason ?? null
            }catch (error) {
                this.showErrors(error)
            }
        },
        download(file) {
            if (this.checkPermission('tuitionassistancereevaluation_download')) {
                TuitionAssistanceService.download(file.uuid)
                    .then(response => {
                        this._downloadFile(response, file.file_name);
                    })
                    .catch(error => {
                        if (error.status == 422) {
                            this.$toast.error(error.data.errors.file[0]);
                        }
                        if (error.status == 406) {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        }
                    });
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        },
        async approve() {
            const result = await this.$swal.fire({
                text: this.$t('are_you_sure_to_approve'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
                icon: 'question'
            });

            if (!result.isConfirmed) return;

            const isValid = await this.$refs.studentForm.validate();
            if (!isValid) return;

            const formData = new FormData();
            formData.append('status', this.formData.status);

            if(this.formData.status === 'approved') {
                formData.append('approved_rate', this.formData.approved_rate);
                formData.append('scholarship_type_id', this.formData.scholarship_type_id);
                formData.append('semester_id', this.formData.semester_id);
            }

            if(this.formData.status === 'declined') {
                formData.append('reason', this.formData.reason);
            }

            try {
                const response = await TuitionAssistanceService.approve(this.$route.params.id, formData);
                this.$toast.success(this.$t('api.' + response.data.message));
                this.$router.push('/tuition/assistance/requests/0');
            } catch (e) {
                this.showErrors(e, this.$refs.studentForm);
            }
        },
    },
};
</script>
